// @flow
import kebabCase from 'lodash/kebabCase'
import * as React from 'react'

import { DEFAULT_IMAGE_RECT } from 'util/image'
import { formatAges, formatHours } from 'util/profile'
import { tuitionPriceRangeFromProfileEnrollment } from 'util/school'
import { applySmallImagePreview } from 'util/uploadcare'
import { type RelatedSchoolListingsDataListings } from './query'
import { Text } from 'core/Text'
import Link from 'ui/Link'
import RatingDisplay from 'ui/RatingDisplay'
import { currency } from 'util/format'

declare var ENV: any

type Props = {
  listing: RelatedSchoolListingsDataListings,
}

export default class RelatedProgram extends React.Component<Props> {
  render = () => {
    return (
      <Link href={listingPagePath(this.props.listing)}>
        <div className="RelatedProgram">
          <div className="RelatedProgram-title">{this.props.listing.name}</div>
          <div className="RelatedProgram-container">
            <div className="RelatedProgram-imageContainer">
              <img className="RelatedProgram-image" role="presentation" src={this.schoolImage} />
            </div>
            <div className="RelatedProgram-body">
              <p className="RelatedProgram-price">{this.priceRange}</p>
              <p className="RelatedProgram-detail">{formatAges(this.props.listing.profile)}</p>
              <p className="RelatedProgram-detail">{formatHours(this.props.listing.profile)}</p>
              {this.renderRatingMaybe()}
            </div>
          </div>
        </div>
      </Link>
    )
  }

  renderRatingMaybe = () => {
    const { aggregateRatings } = this.props.listing
    if (!aggregateRatings || !aggregateRatings.count) return null

    return (
      <div className="RelatedProgram-schoolRating">
        <RatingDisplay value={aggregateRatings.overall} size={13} /> &nbsp; (
        <Text color="gray" size="thirteen">
          {aggregateRatings.count}
        </Text>
        )
      </div>
    )
  }

  get schoolImage(): string {
    const {
      listing: { imageUrl },
    } = this.props

    return imageUrl ? applySmallImagePreview(imageUrl) : DEFAULT_IMAGE_RECT
  }

  get priceRange(): string {
    const range = tuitionPriceRangeFromProfileEnrollment(this.props.listing.profile.enrollment)

    return (range && `${displayPrice(range.min)}-${displayPrice(range.max)}`) || ''
  }
}

export function listingPagePath(listing: RelatedSchoolListingsDataListings) {
  const {
    location: { state, city },
    slug,
  } = listing
  if (!state || !city) return `/${slug}`

  return `/${kebabCase(state)}/${kebabCase(city)}/${slug}`
}

function toNum(amount: string) {
  return Number(amount.replace(/\$|,/g, ''))
}

function displayPrice(price: number | string) {
  const value = typeof price === 'string' ? toNum(price) : price

  // 1 dollar is expected to be expressed as 100.
  return currency(value * 100)
}
